export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./bk.vue?vue&type=template&id=69f8620b"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/view/bk.vue?vue&type=template&id=69f8620b
// module id = eAI6
// module chunks = 0